module.exports = __webpack_public_path__ + "img/hells_gate_small.85e721d9.png";